import { render, staticRenderFns } from "./PrivateClientSalesReport.vue?vue&type=template&id=41facb4e&scoped=true&"
import script from "./PrivateClientSalesReport.vue?vue&type=script&lang=js&"
export * from "./PrivateClientSalesReport.vue?vue&type=script&lang=js&"
import style0 from "./PrivateClientSalesReport.vue?vue&type=style&index=0&id=41facb4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41facb4e",
  null
  
)

export default component.exports